/**
 * CountersBadge — read-only chip showing the operational counters
 * (#74a trash bag count + appliances-cleaned count) that the cleaner
 * recorded at submit time. Rendered alongside StatusChip / PartialUnitChip
 * on TaskDetailPage for any task in a SUBMITTED_STATUSES state.
 */

import type { ReactNode } from 'react'

interface Props {
  trashBagCount:          number
  appliancesCleanedCount: number
}

export function CountersBadge({ trashBagCount, appliancesCleanedCount }: Props): ReactNode {
  return (
    <span
      data-testid="counters-badge"
      data-trash-bag-count={trashBagCount}
      data-appliances-cleaned-count={appliancesCleanedCount}
      style={{
        display:      'inline-block',
        padding:      '0.1rem 0.5rem',
        borderRadius: 'var(--brand-radius-full)',
        background:   'var(--brand-neutral-100)',
        color:        'var(--brand-neutral-700)',
        border:       '1px solid var(--brand-neutral-300)',
        fontSize:     '0.75rem',
        fontWeight:   600,
      }}
    >
      {trashBagCount} bag{trashBagCount === 1 ? '' : 's'} · {appliancesCleanedCount} appliance{appliancesCleanedCount === 1 ? '' : 's'}
    </span>
  )
}
